<template>
  <div>
    <heading title="Contact Us" />

    <div class="surface-100 px-4 py-4 md:px-6 text-sm">
      <div class="grid -mr-3 -ml-3">
        <div class="col-12 lg:col-8 p-4">
          <div class="surface-card grid formgrid p-fluid px-4 py-8">
            <div class="grid">
              <div></div>
              <div class="col-12 md:col-6 px-5">
                <div class="flex align-items-center">
                  <span class="pr-3 mb-3" style="border-radius: 0px">
                    <i class="pi pi-home text-4xl text-green-800"></i>
                  </span>
                  <div class="text-900 text-xl mb-3 font-medium">Address</div>
                </div>

                <span class="text-700 line-height-3">
                  <p class="ml-6 -mb-3 -mt-2">37 Grosvenor</p>
                  <p class="ml-6 -mb-3">Road Bryanston, 2191</p>
                  <p class="ml-6">South Africa</p>
                </span>
              </div>
              <div class="col-12 md:col-6 px-5">
                <div class="flex align-items-center">
                  <span class="pr-3 mb-3" style="border-radius: 0px">
                    <i class="pi pi-user text-4xl text-green-800"></i>
                  </span>
                  <div class="text-900 text-xl mb-3 font-medium">Contact Info</div>
                </div>

                <span class="-r-5 text-700 line-height-3">
                  <p class="ml-6 -mb-3 -mt-2">Telephone: +27 11 234-4440</p>
                  <p class="ml-6 -mb-3">Helpdesk: +27 11 022-4440</p>
                  <p class="ml-6">E-mail: info@sats.ac.za</p>
                </span>
              </div>
              <div class="col-12 md:col-6 px-5">
                <div class="flex align-items-center mt-6">
                  <span class="pr-3 mb-3" style="border-radius: 0px">
                    <i class="pi pi-envelope text-4xl text-green-800"></i>
                  </span>
                  <div class="text-900 text-xl mb-3 font-medium">Postal Address</div>
                </div>

                <span class="-r-5 text-700 line-height-3">
                  <p class="ml-6 -mb-3 -mt-2">South African Theological</p>
                  <p class="ml-6 -mb-3">Seminary</p>
                  <p class="ml-6 -mb-3">PO Box 98988,</p>
                  <p class="ml-6 -mb-3">Sloane Park, 2152</p>
                  <p class="ml-6 -mb-3">South Africa</p>
                </span>
              </div>
              <div class="col-12 md:col-6 px-5">
                <div class="flex align-items-center mt-6">
                  <span class="pr-3 mb-3" style="border-radius: 0px">
                    <i class="pi pi-phone text-4xl text-green-800"></i>
                  </span>
                  <div class="text-900 text-xl mb-3 font-medium">Direct Dial Number</div>
                </div>

                <span class="-r-5 text-700 line-height-3">
                  <p class="ml-6 -mb-3 -mt-2">Registrars, Enrolments,</p>
                  <p class="ml-6 -mb-3">Graduation, Helpdesk</p>
                  <p class="ml-6">+27 11 234 4440</p>
                </span>
              </div>

              <div class="col-12 md:col-6 px-5">
                <div class="flex align-items-center mt-6">
                  <span class="pr-3 mb-3" style="border-radius: 0px">
                    <i class="pi pi-phone text-4xl text-green-800"></i>
                  </span>
                  <div class="text-900 text-xl mb-3 font-medium">Data Protection Officer</div>
                </div>

                <span class="text-700 line-height-3">
                  <p class="ml-6 -mb-3 -mt-2">
                    For queries relating to personal security, POPIA, PAIA, or GDPR, please contact
                    our data protection officer: dpo@sats.ac.za
                  </p>
                </span>
              </div>

              <div class="col-12 md:col-6 px-5"></div>

              <div class="col-12 px-5 mt-8">
                <iframe
                  class="w-full h-25rem"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3584.424438202041!2d28.00377587551535!3d-26.05238177717051!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1e9573b5ee82b923%3A0xea4ae5f1f2fe6aae!2sSouth%20African%20Theological%20Seminary!5e0!3m2!1sen!2sza!4v1725520139158!5m2!1sen!2sza"
                  style="border: 0"
                  allowfullscreen=""
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 lg:col-4 p-4">
          <div class="surface-card p-5">
            <div
              class="flex justify-content-center align-items-center border-bottom-1 pb-3 surface-border"
            >
              <div class="text-2xl font-medium">Submit Inquiry</div>
            </div>
            <form
              class="flex flex-column lg:flex-row flex-wrap lg:align-items-center py-3 my-3 border-bottom-1 surface-border"
              @submit.prevent="sendEmail"
            >
              <div class="hidden" aria-hidden="true">
                <label for="subject">Subject</label>
                <input
                  v-model="body.subject"
                  id="subject"
                  name="subject"
                  type="text"
                  tabindex="-1"
                  autocomplete="off"
                />
              </div>
              <div class="col-12 lg:col-6 field mb-0">
                <label for="first_name" class="text-900 font-medium mb-1">Name </label>
                <input
                  v-model="body.first_name"
                  id="first_name"
                  type="text"
                  class="p-inputtext w-full mb-1"
                />
              </div>
              <div class="col-12 lg:col-6 field mb-0">
                <label for="last_name" class="text-900 font-medium mb-1">Surname </label>
                <input
                  v-model="body.last_name"
                  id="last_name"
                  type="text"
                  class="p-inputtext w-full mb-1"
                />
              </div>
              <div class="col-12 field">
                <label for="email" class="text-900 font-medium mb-1">Email </label>
                <input
                  v-model="body.email"
                  id="email"
                  type="email"
                  class="p-inputtext w-full mb-1"
                  required
                />
              </div>
              <div class="col-12 field">
                <label for="contact_number" class="text-900 font-medium mb-1"
                  >Contact Number
                </label>
                <input
                  v-model="body.contact_number"
                  id="contact_number"
                  type="text"
                  class="p-inputtext w-full mb-1"
                />
              </div>
              <div class="col-12 field">
                <label for="inquiry" class="text-900 font-medium mb-1">Inquiry </label>
                <Textarea
                  v-model="body.inquiry"
                  id="inquiry"
                  rows="5"
                  class="w-full mb-1"
                  required
                />
              </div>
              <TurnstileWidget
                ref="turnstileWidget"
                v-model="turnstileToken"
                action="contact_form"
                class="col-12 field"
              />
              <Button
                class="p-button-primary w-full mt-3 bg-green-900 border-0 border-noround"
                label="Submit"
                type="submit"
                :loading="isSubmitting"
                :disabled="!turnstileToken"
              />
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useToast } from 'primevue/usetoast'

const toast = useToast()
const isSubmitting = ref(false)
const turnstileWidget = ref(null)
const turnstileToken = ref('')
const title = 'Contact Us'
const description =
  'Contact the South African Theological Seminary for enquiries, student support, and admissions assistance.'

useSeoMeta({
  title,
  description,
  ogTitle: title,
  ogDescription: description,
  twitterTitle: title,
  twitterDescription: description,
})

const body = ref({
  first_name: '',
  last_name: '',
  email: '',
  contact_number: '',
  inquiry: '',
  subject: '',
})

const sendEmail = async () => {
  if (!turnstileToken.value) {
    toast.add({
      severity: 'warn',
      summary: 'Verification required',
      detail: window.turnstile
        ? 'Please complete the security verification before submitting your inquiry.'
        : 'Security verification could not load. Please refresh the page.',
      life: 5000,
    })
    return
  }

  isSubmitting.value = true

  try {
    await $fetch('/api/email/send', {
      method: 'POST',
      body: {
        ...body.value,
        turnstile_token: turnstileToken.value,
      },
    })

    toast.add({
      severity: 'success',
      summary: 'Inquiry sent',
      detail: 'Your inquiry has been successfully sent.',
      life: 3000,
    })

    Object.keys(body.value).forEach((key) => {
      body.value[key] = ''
    })
  } catch {
    toast.add({
      severity: 'error',
      summary: 'Inquiry not sent',
      detail: 'We could not send your inquiry. Please try again.',
      life: 5000,
    })
  } finally {
    turnstileWidget.value?.reset()
    isSubmitting.value = false
  }
}
</script>

<style lang="scss">
input {
  height: 2.5rem;
}
</style>
